import { render } from "./AssetsList.vue?vue&type=template&id=2c2716b8&scoped=true"
import script from "./AssetsList.vue?vue&type=script&lang=js"
export * from "./AssetsList.vue?vue&type=script&lang=js"

import "./AssetsList.vue?vue&type=style&index=0&id=2c2716b8&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2716b8"]])

export default __exports__